export enum ListTypesTextEnum {
  TOTAL = 'Перейти к перечню всех КНМ',
  UNDER_CONSIDERATION = 'Перейти к перечню КНМ на рассмотрении',
  AGREED = 'Перейти к перечню согласованных КНМ',
  EXCLUDED = 'Перейти к перечню исключенных КНМ',
  APPEALED = 'Перейти к перечню КНМ, исключение которых обжаловано',
  COMMENTS_EXIST = 'Перейти к перечню КНМ, к которым есть замечания',
  FILL_IN_PROCESS = 'Перейти к перечню КНМ в процессе заполнения',
  READY_FOR_APPROVE = 'Перейти к перечню КНМ готовых к согласованию',
}
